import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import categorySlice from './slices/categorySlice'
import visaSlice from './slices/visaSlice'
import locationSlice from './slices/locationSlice'
import photoSlice from './slices/photoSlice'
import carouselSlice from './slices/carouselSlice'
import postSlice from './slices/postSlice'
import frontViewSlice from './slices/frontViewSlice'
import favoriteSlice from './slices/favoriteSlice'

export const store = configureStore({
  reducer: {
    frontViewData: frontViewSlice,
    favIds: favoriteSlice,
    auth: authSlice,
    post: postSlice,
    category: categorySlice,
    visa: visaSlice,
    location: locationSlice,
    photo: photoSlice,
    carousel: carouselSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch